import { orchestrator } from 'satcheljs';
import { startDomainEnroll } from '../actions/startDomainEnroll';
import { traceCreateEmailButtonClick } from '../utils/domainOptionTracer';
import { hideFullOptions } from 'owa-options-core';
import * as React from 'react';
import { PremiumDomainConnectFirstStep } from 'owa-domain-connect';
import { showModal } from 'owa-modal';

export default orchestrator(startDomainEnroll, async function startDomainEnroll() {
    traceCreateEmailButtonClick();
    hideFullOptions();
    mountDomainConnectFirstStep();
});

function mountDomainConnectFirstStep() {
    const WrappedComponent = () => (
        <PremiumDomainConnectFirstStep mountFromDomainDashBoard={true} />
    );
    showModal(WrappedComponent);
}
